import {Fragment as _Fragment, jsx as _jsx, jsxs as _jsxs} from "react/jsx-runtime";
export let lastModified = undefined;
export let frontmatter = {
  "title": "OpenAPI specification",
  "description": "OpenAPI specification for self-hosted Remote Cache servers."
};
export let structuredData = {
  "contents": [{
    "heading": "",
    "content": "This page is a stub so that the sidebar shows this title at the top of the sidebar."
  }, {
    "heading": "",
    "content": "The route it produces is redirected in next.config.ts."
  }],
  "headings": []
};
export const toc = [];
function _createMdxContent(props) {
  const _components = {
    p: "p",
    ...props.components
  };
  return _jsxs(_Fragment, {
    children: [_jsx(_components.p, {
      children: "This page is a stub so that the sidebar shows this title at the top of the sidebar."
    }), "\n", _jsx(_components.p, {
      children: "The route it produces is redirected in next.config.ts."
    })]
  });
}
export default function MDXContent(props = {}) {
  const {wrapper: MDXLayout} = props.components || ({});
  return MDXLayout ? _jsx(MDXLayout, {
    ...props,
    children: _jsx(_createMdxContent, {
      ...props
    })
  }) : _createMdxContent(props);
}
